<template>
    <div class="free-trial-bar-wrap">
        <div class="free-trial-bar">
            <p class="text-white text-center subtitle ">{{ $t('free_trial.your_free_trial_ends_in') }} {{ $tc('free_trial.days', subscription_ends_days) }}.</p> <a @click.prevent="upgradePlan()" class="button button-m button-secondary">{{ $t('free_trial.upgrade') }}</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'subscription_ends_days': Number
        },
        methods: {
            upgradePlan() {
                if (typeof mixpanel === 'object') {
                    mixpanel.track("Clicked on Upgrade a plan");
                }

                window.location.href = "/choose-a-plan";
            }
        }
    }
</script>
